<template>
  <section class="product-detail-head">
    <div class="container">
      <div class="detail-page-head">
        <div class="detail-headings">
          <div class="star-rated">
            <ul class="list-rating">
              <li>
                <div class="car-brand">
                  <span>
                    <img src="@/assets/img/icons/car-icon.svg" alt="img" />
                  </span>
                  {{ carDetails?.car?.type }}
                </div>
              </li>
              <li>
                <span class="year">{{ carDetails?.car?.year }}</span>
              </li>
              <!-- <li class="ratings">
                <i class="fas fa-star filled"></i>
                <i class="fas fa-star filled"></i>
                <i class="fas fa-star filled"></i>
                <i class="fas fa-star filled"></i>
                <i class="fas fa-star filled"></i>
                <span class="d-inline-block average-list-rating">(5.0)</span>
              </li> -->
            </ul>
            <div class="camaro-info">
              <h3>
                {{ carDetails?.car?.brand?.name }}
                {{ carDetails?.car?.model?.name }}
              </h3>
              <div class="camaro-location">
                <div class="camaro-location-inner">
                  <i class="bx bx-map"></i>
                  <span
                    >الموقع: {{ carDetails?.car?.city.name }} -
                    {{ carDetails?.car?.district.name }}</span
                  >
                </div>
                <!-- <div class="camaro-location-inner">
                  <i class="bx bx-show"></i>
                  <span>المشاهدات: 250 </span>
                </div> -->
                <div class="camaro-location-inner">
                  <i class="bx bx-car"></i>
                  <span
                    >تاريخ الإنشاء:
                    {{ convertDate(carDetails?.car?.created_at) }} ({{
                      timeAgo(carDetails?.car?.created_at)
                    }})</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="details-btn">
          <span class="total-badge"
            ><i class="bx bx-calendar-edit"></i>إجمالي الحجوزات: 300</span
          >
          <a href="javascript:;"> <i class="bx bx-git-compare"></i>مقارنة</a>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ListingHead",
  props: {
    carDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    timeAgo(date) {
      if (!date) return "";
      const now = new Date();
      const created = new Date(date);
      const diff = Math.floor((now - created) / 1000);

      if (diff < 60) return "منذ ثوانٍ";
      if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
      if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
      if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
      if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
      return `منذ ${Math.floor(diff / 31104000)} سنة`;
    },
    convertDate(createdAt) {
      if (createdAt) {
        const date = new Date(createdAt);
        const readableDate = date.toLocaleString("ar-EG", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
        return readableDate;
      }
    },
  },
};
</script>
